import styled from 'styled-components';
import { colors, ApButtonGroup } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	height: 48px;
	display: flex;
	align-items: center;
	border-bottom: 1px solid ${colors.grey3};
	padding: 0 32px;
	background-color: ${colors.white};
	z-index: 1;
`;

export const Divider = styled.div`
	border-left: 1px solid ${colors.grey3};
	height: 24px;
	margin: 0 16px;
	align-self: center;
`;

export const TabsWrapper = styled.div`
	display: flex;
`;

export const ControlsWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-left: auto;

	> button {
		margin-left: 16px;
	}
`;

export const TooltipContent = styled.div`
	font-size: 11px;
	text-align: left;
`;

export const IconWrapper = styled.div`
	height: 16px;
	width: 16px;
`;

export const ButtonGroup = styled(ApButtonGroup)`
	padding-right: 16px;

	> button {
		width: 144px;
	}
`;

export const ControlGroup = styled.div`
	padding-left: 9px;
`;

export const CheckboxLabel = styled.div`
	line-height: 14px;
	font-size: 12px;
`;

export const SaveMessageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const SaveMessageLabel = styled.div`
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 13px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	margin-left: 8px;
`;
